import MobileDetect from 'aria-viewer/utils/mobileDetect'
import { stopMapClickEventPropogation, moveToLocation } from './coordinates_v3'
import mobileMenu from '../../../legacy/mobileMenu'

export default function InfoBox(opts) {
    google.maps.OverlayView.call(this)
    this.latlng_ = opts.latlng
    this.map_ = opts.map

    this.breakpoint_ = 430
    this.firstTime_ = true

    if ($(window).width() <= this.breakpoint_) {
        this.currentClass_ = 'mobile'
        this.offsetVertical_ = -85
        this.offsetHorizontal_ = -77
        this.padX_ = 30
    } else {
        this.currentClass_ = 'desktop'
        this.offsetVertical_ = -295
        this.offsetHorizontal_ = -42
        this.padX_ = 40
    }

    this.offsetHeight_ = 0
    this.bodyHeight_ = 45
    this.bubbleText = opts.bubbleText
    this.resPath = opts.resourcesPath || ''
    this.descriptionHidden_ = opts.descriptionHidden
    this.id = opts.id
    this.mapController = opts.mapController
    this.delegate = opts.mapController.delegate
    this.isMobile = typeof opts.isMobile !== 'undefined' ? opts.isMobile : MobileDetect.mobile()

    var me = this
    this.boundsChangedListener_ = google.maps.event.addListener(this.map_, 'bounds_changed', function() {
        return me.panMap.apply(me)
    })
    this.setMap(this.map_)
}

InfoBox.prototype = new google.maps.OverlayView()

InfoBox.prototype.remove = function() {
    if (this.div_) {
        this.div_.remove()
        this.div_ = null
    }
}
InfoBox.prototype.draw = function() {
    var showDescription = this.createElement()

    if (!this.div_) return
    // Calculate the DIV coordinates of two opposite corners of our bounds to
    // get the size and position of our Bar
    var pixPosition = this.getProjection().fromLatLngToDivPixel(this.latlng_)
    if (!pixPosition) return

    // Now position our DIV based on the DIV coordinates of our bounds
    var vPad = this.currentClass_ == 'mobile' ? 45 : 25
    this.div_.css({
        left: pixPosition.x + this.offsetHorizontal_ + 'px',
        top: pixPosition.y - this.div_.height() - vPad + 'px',
        display: 'block',
    })

    if (this.firstTime_ && this.automaticAudioEnabled && this.delegate.shouldPlayAudio) {
        $('.button-audio').addClass('play')
        this.delegate.playAudio(this.id)
        this.firstTime_ = false
    }
}

InfoBox.prototype.responsive = function(isVisible) {
    var map = this.map_
    var infoBox = map.activeTooltip ? map.activeTooltip : this
    var newClass = $(window).width() <= infoBox.breakpoint_ ? 'mobile' : 'desktop'
    var currentStop = this.mapController.currentStop
    if (!$('.infoBox').hasClass(newClass)) {
        if (newClass == 'desktop' && $('#container').position().left != 0) {
            mobileMenu.rightMenu()
        }
        moveToLocation(currentStop.id, currentStop.startLat, currentStop.startLng)
    }
}

InfoBox.prototype.clearListeners = function() {
    $('#media')
        .off('click', '.prev-arrow')
        .off('click', '.next-arrow')
        .off('click', 'a.close-btn')
        .off('click', 'a.expand')
        .off('click', '#media-title')
    $('#media .gallery').off('click', 'thumbnail img')
    $('#media [class*=module-], .modules [class*=module-]').off('click')
}

InfoBox.prototype.mediaListeners = function() {
    var scope = this

    this.clearListeners()

    // TODO, this should be removed after fixing the event attaching bug in mediaModules.js
    if (typeof MediaModules != 'undefined') MediaModules._addHooks()

    $('[class*=module-]')
        .not('.module-container')
        .not('.module-videos')
        .click(function() {
            if (scope.mapController.currentStop && scope.delegate.shouldPlayAudio) {
                scope.delegate.playAudio(scope.mapController.currentStop.id)
            }
        })
    $('.module-videos, .module-icon-videos').click(function() {
        if (scope.mapController.currentStop) {
            scope.delegate.stopAudio(scope.mapController.currentStop.id)
        }
    })

    var mediaMap = {
        photos: 'photo',
        panos: 'panorama',
        videos: 'video',
    }

    $('.mobile-info .bubbleMedia .badge').click(function(event) {
        var mediaType = event.currentTarget.type,
            stopid = scope.id,
            mediaObj = {
                mediaType: mediaMap[mediaType],
            }
        scope.mapController.supplementalMediaListener(mediaObj, stopid)
    })

    $('.infoBox').on('mousemove', function(event) {
        stopMapClickEventPropogation(event)
    })
    $('.infoBox').on('mouseover mousedown touchstart', function() {
        $('.tooltip').removeClass('opaque')
    })
    var infoBox = this
    $('.button-audio').click(function(event) {
        stopMapClickEventPropogation(event)
        $('.button-audio').toggleClass('play')
        if ($(this).hasClass('play')) {
            infoBox.delegate.shouldPlayAudio = true
            infoBox.delegate.playAudio(infoBox.id)
        } else {
            infoBox.delegate.shouldPlayAudio = false
            infoBox.delegate.stopAudio(infoBox.id)
        }
    })
    $('.contentDiv .button-close').click(function(event) {
        stopMapClickEventPropogation(event)
        scope.mapController.mapClicked(scope.map_)
    })
    $('.bubbleText .desc-expand-container').click(function(event) {
        infoBox.showDescription(!$(this).hasClass('show'))
    })
    $('.mobileText').on('touchstart click', function() {
        mobileMenu.rightMenu()
    })
}
InfoBox.prototype.showDescription = function(visible) {
    var desc = $('.bubbleText .description')
    var infoBox = this
    var duration = 200,
        pad = 10,
        map = this.map_

    if (visible) {
        $('.bubbleText .desc-expand-container').addClass('show')
        infoBox.offsetHeight_ = $('.bubbleText .fullText').height() - $('.bubbleText .shortText').height()

        $('.bubbleText .description').animate(
            { height: pad + $('.bubbleText .fullText').height() },
            duration,
            function() {
                desc.addClass('show')
            }
        )
        $('.infoBox').animate({ top: '-=' + infoBox.offsetHeight_ }, duration, function() {
            map.activeTooltip.offsetVertical_ -= infoBox.offsetHeight_
            infoBox.panMap()
        })

        //make the max height relative to it's own height so text in description won't get cut off
        $('.bubbleText .fullText').css({ 'max-height': $('.bubbleText .fullText').height() })
    } else {
        $('.bubbleText .desc-expand-container').removeClass('show')
        $('.bubbleText .description').animate(
            { height: pad + $('.bubbleText .shortText').height() },
            duration,
            function() {
                desc.removeClass('show')
            }
        )
        $('.infoBox').animate({ top: '+=' + infoBox.offsetHeight_ }, duration, function() {
            map.activeTooltip.offsetVertical_ += infoBox.offsetHeight_
        })
    }
}

InfoBox.prototype.createElement = function() {
    var panes = this.getPanes()
    var div = this.div_
    if (!div || !div[0]) {
        this.offsetHeight_ = 0
        // This does not handle changing panes.  You can set the map to be null and
        // then reset the map to move the div.
        var text = this.bubbleText.getBody()
        var textwidthSpan = $('#textwidthSpan')
        textwidthSpan.html(text)

        textwidthSpan.css('display', 'none')
        div = this.div_ = $('<div>').addClass('infoBox mediaPanelPopup ' + this.currentClass_)

        var leftSide = $('<img>').addClass('leftSide')
        leftSide.attr('src', this.resPath + 'images/bubbleleftside.png')

        var rightSide = $('<img>').addClass('rightSide')
        rightSide.attr('src', this.resPath + 'images/bubblerightside.png')

        var anchor = $('<div>').addClass('anchor')

        var bodyDiv = $('<div>')
            .addClass('bodyDiv')
            .attr('id', 'optionsPanelContent')

        var contentDiv = $('<div>').addClass('contentDiv')
        contentDiv.html(text)

        if (contentDiv.find('.bubbleText .description').hasClass('noexpand')) {
            contentDiv.find('.desc-expand-container').addClass('noexpand')
            if (this.currentClass_ == 'desktop') {
                this.offsetVertical_ += 32
            }
        }
        if (contentDiv.find('.bubbleText .bubbleMedia a').length == 0 && this.currentClass_ == 'desktop') {
            this.offsetVertical_ += 90
        }
        contentDiv.find('#audioPlayer .audioProgress').css('width', '0%')

        function removeInfoBox(ib) {
            return function() {
                ib.setMap(null)
            }
        }
        div.append(contentDiv)
        contentDiv.append(anchor)

        panes.floatPane.appendChild(div[0])
        panes.floatPane.style.zIndex = '10000'
        google.maps.event.addDomListener(div[0], 'click', stopMapClickEventPropogation) // cancels click
        google.maps.event.addDomListener(div[0], 'dblclick', stopMapClickEventPropogation) // cancels double click
        google.maps.event.addDomListener(div[0], 'mousedown', stopMapClickEventPropogation) // cancels move

        this.mediaListeners()
        this.panMap()
        return true
    } else {
        // The panes have not changed, so no need to create or move the div.
    }
    return false
}
/* Pan the map to fit the InfoBox.
 */
InfoBox.prototype.panMap = function() {
    // if we go beyond map, pan map
    var map = this.map_
    var bounds = map.getBounds()
    if (!bounds) return

    // The position of the infowindow
    var position = this.latlng_

    // center the map to the new shifted center
    map.panTo(new google.maps.LatLng(position.lat(), position.lng()))

    // Remove the listener after panning is complete.
    google.maps.event.removeListener(this.boundsChangedListener_)
    this.boundsChangedListener_ = null
}
